import rxios from '../common/rxios'
import { from, merge, of } from 'rxjs'
import { map, mergeMap, reduce } from 'rxjs/operators'
import {
  map as _map,
  reduce as _reduce,
  filter as _filter,
  range as _range,
  isEmpty as _isEmpty,
  find as _find,
  values as _values,
  get as _get
} from 'lodash-es'
import saveAs from 'file-saver'
import moment from 'moment'

const CalculationActions = {
  COMPUTE_AS_QUANTITY: ({ counterVolume }) => ({
    quantity: counterVolume
  }),
  SPLIT_COUNTER_VOLUME_1BY1: ({ counterName, counterVolume }) =>
    _map(new Array(Number(counterVolume)), () => ({ counterName, counterVolume: 1 })),
  FOLLOW_COUNTER_VOLUME: ({ counterName, calculationAction, items }) => {
    const targetCounterName = calculationAction.split(':')[1]
    const targetItem = _find(_values(items), { metadataId: targetCounterName })
    if (!!targetItem === false) return []
    return [{ counterName, counterVolume: targetItem.counterVolume }]
  },
  FOLLOW_NAME_AND_UNIT: ({ counterName, calculationAction, items }) => {
    const targetCounterName = calculationAction.split(':')[1]
    const countUnit = calculationAction.split(':')[2]
    const targetItem = _find(_values(items), { counterName: counterName })
    const targetVolume = targetItem.counterVolume
    //1~4 = 4 / 5~8 = 8 / 9~12 = 12 / ...
    const counterVolume = Math.ceil(targetVolume / countUnit) * countUnit
    return [{ counterName: targetCounterName, counterVolume: counterVolume }]
  },
  FOLLOW_NAME_BY_UNIT_AND_UNIT: ({ counterName, calculationAction, items }) => {
    const targetCounterName = calculationAction.split(':')[1]
    const countUnit = calculationAction.split(':')[2]
    const targetItem = _find(_values(items), { counterName: counterName })
    const targetVolume = targetItem.counterVolume
    //1~8 = 8 / 9~16 = 16 / 17~24 = 24 / ...
    const counterVolume = Math.ceil(targetVolume / countUnit) * countUnit
    const counterNameByUnit = targetCounterName + `.${counterVolume}vcpu`
    return [{ counterName: counterNameByUnit, counterVolume: counterVolume }]
  },
  FOLLOW_NAME_BY_VOLUME_LOG2_POWER: ({ counterName, calculationAction, items }) => {
    const targetCounterName = calculationAction.split(':')[1]
    const targetItem = _find(_values(items), { counterName: counterName })
    const targetVolume = targetItem.counterVolume
    //1 = 1 / 2 = 2 / 3~4 = 4 / 5~8 = 8 / 9~16 = 16 / 17~32 = 32 / 33~ x
    const logVolume = Math.log2(targetVolume)
    const ceilVolume = Math.ceil(logVolume)
    const counterVolume = Math.pow(2, ceilVolume)
    const counterNameByVolume = targetCounterName + `.${counterVolume}vcpu`
    return [{ counterName: counterNameByVolume, counterVolume: counterVolume }]
  },

  DOUBLE_ITEM: ({ calculationAction, items }) => {
    const targetItemIds = calculationAction.split(':')[1].split(',')
    return _reduce(
      targetItemIds,
      (result, targetItemId) => {
        const targetItem = items[targetItemId]
        if (!!targetItem && !!targetItem.counterName)
          result.push({ counterName: targetItem.counterName, counterVolume: targetItem.counterVolume })
        return result
      },
      []
    )
  },
  CHANGE_TO_HA: ({ calculationAction, items }) => {
    const targetItemIds = calculationAction.split(':')[1].split(',')
    return _reduce(
      targetItemIds,
      (result, targetItemId) => {
        const targetItem = items[targetItemId]
        if (!!targetItem && !!targetItem.counterName) {
          result.push({
            counterName: targetItem.counterName
              .replace('rds-mssql.kr1.compute', 'rds-mssql.kr1.compute.ha')
              .replace('rds-mssql.kr1.storage.volume', 'rds-mssql.kr1.storage.ha.volume'),
            counterVolume: targetItem.counterVolume
          })
        }
        return result
      },
      []
    )
  },
  SECOND_TO_MONTH: ({ counterName, items }) => {
    const targetItem = _find(_values(items), { metadataId: counterName })
    if (!!targetItem === false) return []
    return [{ counterName, counterVolume: targetItem.counterVolume * 60 * 60 * 24 * 30 }]
  },
  HOUR_TO_MONTH: ({ counterName, items }) => {
    const targetItem = _find(_values(items), { metadataId: counterName })
    if (!!targetItem === false) return []
    return [{ counterName, counterVolume: targetItem.counterVolume * 24 * 30 }]
  },
  DAY_TO_MONTH: ({ counterName, items }) => {
    const targetItem = _find(_values(items), { metadataId: counterName })
    if (!!targetItem === false) return []
    return [{ counterName, counterVolume: targetItem.counterVolume * 30 }]
  }
}

function processItemsDataForCalculating(itemsMapData) {
  return _reduce(
    itemsMapData,
    (result, item) => {

      const existCounterNameVolume = !!item.counterName && !!item.counterVolume
      const existCalculationAction = !!item.calculationAction
      if (existCalculationAction && item.calculationAction === 'COMPUTE_AS_QUANTITY') {
        // instance, RDS for MySQL 의 경우, 수량 카운터 네임이 없다. 그래서 계산 값들에 대해서 입력된 수량 만큼 곱해준다.
        result = {
          ...result,
          ...CalculationActions[item.calculationAction](item)
        }
      } else if (existCounterNameVolume && existCalculationAction && item.calculationAction === 'SPLIT_COUNTER_VOLUME_1BY1') {
        // vaccine의 경우, counterVolume 만큼 counterName을 보내야한다.
        result.usages.push(...CalculationActions[item.calculationAction](item))
      } else if (existCounterNameVolume && existCalculationAction && item.calculationAction.startsWith('FOLLOW_COUNTER_VOLUME')) {
        // Web Firewall (Managed) 앞에 입력한 수량으로 counterVolume을 요청해야한다.
        result.usages.push(...CalculationActions['FOLLOW_COUNTER_VOLUME']({ ...item, items: itemsMapData }))
      } else if (existCounterNameVolume && existCalculationAction && item.calculationAction.startsWith('FOLLOW_NAME_AND_UNIT')) {
        // MSSQL INSTANCE 뒤에 입력한 counter name으로, volume으로 사용량을 나누고 올림처리 한 후에 volume을 다시 곱해야한다.
        result.usages.push(...CalculationActions['FOLLOW_NAME_AND_UNIT']({ ...item, items: itemsMapData }))
      } else if (existCounterNameVolume && existCalculationAction && item.calculationAction.startsWith('FOLLOW_NAME_BY_UNIT_AND_UNIT')) {
        // Tibero Instance 뒤에 입력한 counter name을 volume을 포함한 이름으로 바꾸고, volume으로 사용량을 나누고 올림처리 한 후에 volume을 다시 곱해야한다.
        result.usages.push(...CalculationActions['FOLLOW_NAME_BY_UNIT_AND_UNIT']({ ...item, items: itemsMapData }))
      } else if (
        existCounterNameVolume &&
        existCalculationAction &&
        item.calculationAction.startsWith('FOLLOW_NAME_BY_VOLUME_LOG2_POWER')
      ) {
        // WebtoB Instance, JEUS Instance 뒤의 volume을 밑이2인 log함수의 수로 넣고 나온 값을 올림처리해서 2의 지수로 다시 넣는 값으로 name에 포함해 전송한다.
        result.usages.push(...CalculationActions['FOLLOW_NAME_BY_VOLUME_LOG2_POWER']({ ...item, items: itemsMapData }))
      } else if (item.counterVolume > 0 && existCalculationAction && item.calculationAction.startsWith('DOUBLE_ITEM')) {
        // RDS for Mysql의 HA의 경우, INSTANCE Item 을 한번 더 보내줘야한다.
        result.usages.push(...CalculationActions['DOUBLE_ITEM']({ ...item, items: itemsMapData }))
      } else if (item.counterVolume > 0 && existCalculationAction && item.calculationAction.startsWith('CHANGE_TO_HA')) {
        // RDS for Mssql의 HA의 경우, 스토리지 계산을 제거하고 Item 의 카운터 네임에 ha를 붙여 재 계산한다.
        const exclusions = ['rds-mssql.kr1.storage.volume', 'rds-mssql.kr1.compute']
        result.usages = _filter(result.usages, usage => {
          const counterName = _get(usage, 'counterName', '')
          return !exclusions.some(exclusion => counterName.startsWith(exclusion))
        })
        result.usages.push(...CalculationActions['CHANGE_TO_HA']({ ...item, items: itemsMapData }))
      } else if (existCounterNameVolume && existCalculationAction && item.calculationAction === 'DAY_TO_MONTH') {
        // DNS Plus DNS zone 의 경우 DAY 단위로 값을 보내 주기 때문에 월 단위로 보내 줘야 한다.
        result.usages.push(...CalculationActions[item.calculationAction]({ ...item, items: itemsMapData }))
      } else if (existCounterNameVolume && existCalculationAction && item.calculationAction === 'HOUR_TO_MONTH') {
        // DNS Plus DNS Endpoint 의 경우 HOUR 단위로 값을 보내 주기 때문에 월 단위로 보내 줘야 한다.
        result.usages.push(...CalculationActions[item.calculationAction]({ ...item, items: itemsMapData }))
      } else if (existCounterNameVolume && existCalculationAction && item.calculationAction === 'SECOND_TO_MONTH') {
        // NCS 의 경우 SECOND(초) 단위로 값을 보내 주기 때문에 월 단위로 보내 줘야 한다.
        result.usages.push(...CalculationActions[item.calculationAction]({ ...item, items: itemsMapData }))
      } else if (existCounterNameVolume && existCalculationAction && item.calculationAction === 'SUM_COUNTER_VOLUME') {
        // 같은 카운터네임을 가진 아이템의 counterVolume 을 합쳐서 하나만 보낸다
        const usage = result.usages.find(usage => usage.counterName === item.counterName)
        if (usage) {
          usage.counterVolume = Number(usage.counterVolume) + Number(item.counterVolume)
        } else {
          result.usages.push({ counterName: item.counterName, counterVolume: item.counterVolume })
        }
      } else if (existCounterNameVolume) {
        // 일반 케이스
        result.usages.push({ counterName: item.counterName, counterVolume: item.counterVolume })
      }
      return result
    },
    {
      usages: [],
      quantity: 1
    }
  )
}

export const calculationService = {
  getLnbHierarchyList$() {
    return merge(
      of(require('./json/getCalculationLnbHierarchyList$.json$').hierarchyList),
      rxios.get(`${domain.homepage}/homepage/v1/calculation-lnb/hierarchies`).pipe(map(response => response.data.hierarchyList))
    )
  },
  getServices$(parentProductUiId, region) {
    // region == regionCode
    return rxios
      .get(
        `/homepage/v1/calculation-services/${parentProductUiId}`,
        {
          params: {
            region
          }
        },
        {
          ignoreMoveAnchor: true
        }
      )
      .pipe(map(response => response.data.serviceList))
  },
  calculate$(country, itemsMapData) {
    const { usages, quantity } = processItemsDataForCalculating(itemsMapData)
    if (_isEmpty(usages)) return of(0)
    return rxios
      .post(
        `/billing-api/billing/v4.0/products/volume-rate/prices`,
        {
          country,
          usages
        },
        {
          ignoreMoveAnchor: true
        }
      )
      .pipe(
        mergeMap(response => from(response.data.prices)),
        map(price => price.price),
        reduce((acc, value) => acc + value, 0),
        map(acc => acc * quantity)
      )
  },
  getCountryPolicy$(country, countryPolicyTypeCode) {
    return rxios
      .get(
        `/billing-api/billing/v4.0/country-policies/${country}`,
        {
          params: {
            countryPolicyTypeCode: countryPolicyTypeCode,
            month: moment()
              .tz('Asia/Seoul')
              .format('YYYY-MM')
          }
        },
        {
          ignoreMoveAnchor: true
        }
      )
      .pipe(map(response => response.data.countryPolicies[0].value))
  },
  saveExcel(fileName, payload) {
    rxios
      .post(`/homepage/v1/estimated-excel/download`, payload, { responseType: 'blob', ignoreMoveAnchor: true }, false)
      .subscribe(response => saveAs(new Blob([response.data]), `${fileName}.xlsx`))
  },
  getRegions$(regionStatusCode) {
    return rxios
      .get(
        `/cab-api/cab/v4.0/regions`,
        {
          params: {
            regionStatusCode: regionStatusCode
          }
        },
        { ignoreMoveAnchor: true }
      )
      .pipe(map(response => response.data.regionList))
  },
  sendEmail$({ recipientEmail, contents, period, monthlyPrice, totalPrice, footerMsg, isJp }) {
    return rxios
      .post(
        '/homepage/v1/calculation/estimated-email',
        {
          recipientEmail,
          contents,
          period,
          monthlyPrice,
          totalPrice,
          footerMsg,
          isJp
        },
        {
          ignoreMoveAnchor: true
        }
      )
      .pipe(map(response => response.data))
  },
  getServiceDescription$(productUiIds, lang, region) {
    return rxios
      .get(`/homepage/v1/calculation-service-descriptions`, {
        params: {
          productUiIds: productUiIds.join(','),
          lang,
          region
        }
      })
      .pipe(map(response => response.data.descriptions))
  }
}
